import { SpotListPage } from '@/features/pages/spots'
import type { NextPage } from 'next'

/** v1の後方互換のためだけに作成。2027年6月以降に削除可能か確認する */
const SpotPage: NextPage = () => {
  return <SpotListPage />
}

export default SpotPage

export { getStaticPaths, getStaticProps } from '@/components/Functional/utils/getStaticFunctions'
